import { render, staticRenderFns } from "./UploadPlanta.vue?vue&type=template&id=67e50288&lang=pug&"
import script from "./UploadPlanta.vue?vue&type=script&lang=js&"
export * from "./UploadPlanta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports